import React, { memo } from "react";
import { colors } from "theme";
import { Fonts } from "theme/fontConfig";

const styles = {
  body: {
    color: colors.textColor,
    fontSize: Fonts.GeneralLargeBodyFont.fontSize,
    fontWeight: Fonts.GeneralLargeBodyFont.fontWeight,
  },
};
export const Text = memo(({ style, children, ...rest }) => {
  return (
    <span
      style={{
        ...styles.body,
        ...style,
      }}
      {...rest}
    >
      {children}
    </span>
  );
});
